module.exports = __webpack_public_path__ + "static/img/damskie.236c21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/damskie.png
// module id = 300
// module chunks = 2